import { get } from 'lodash';
import Vue from 'vue';

Vue.set(Vue.prototype, '$get', get);
